var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        { attrs: { xs5: "", sm2: "" } },
        [
          _c(
            "v-menu",
            {
              ref: "menu",
              attrs: {
                "close-on-content-click": false,
                "nudge-right": 20,
                "return-value": _vm.time,
                lazy: "",
                transition: "scale-transition",
                "offset-y": "",
                "full-width": "",
                "max-width": "290px",
                "min-width": "290px",
              },
              on: {
                "update:returnValue": function ($event) {
                  _vm.time = $event
                },
                "update:return-value": function ($event) {
                  _vm.time = $event
                },
              },
              model: {
                value: _vm.menu2,
                callback: function ($$v) {
                  _vm.menu2 = $$v
                },
                expression: "menu2",
              },
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Polling time",
                  "prepend-icon": "access_time",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return undefined
                    },
                  },
                ]),
                model: {
                  value: _vm.time,
                  callback: function ($$v) {
                    _vm.time = $$v
                  },
                  expression: "time",
                },
              }),
              _vm._v(" "),
              _vm.menu2
                ? _c("v-time-picker", {
                    on: {
                      change: function ($event) {
                        return _vm.$refs.menu.save(_vm.time)
                      },
                    },
                    model: {
                      value: _vm.time,
                      callback: function ($$v) {
                        _vm.time = $$v
                      },
                      expression: "time",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs1: "", sm1: "" } }),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs5: "", sm2: "" } },
        [
          _c("v-select", {
            attrs: {
              items: _vm.intervals,
              label: "Polling Interval",
              required: "",
            },
            model: {
              value: _vm.selectedPollingInterval,
              callback: function ($$v) {
                _vm.selectedPollingInterval = $$v
              },
              expression: "selectedPollingInterval",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }